import React, { useMemo, useRef, useState } from 'react';
import Fuse from 'fuse.js';
import { useHistory } from 'react-router-dom';
import InputBase from '@material-ui/core/InputBase';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';
import SearchIcon from '@material-ui/icons/Search';
import { useContent, Concept } from './contentContext';

const SearchBar = () => {
  const { concepts } = useContent();
  const history = useHistory();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const fuse = useMemo(
    () =>
      new Fuse(concepts, {
        keys: [
          { name: 'title', weight: 0.5 },
          { name: 'tags', weight: 0.3 },
          { name: 'description', weight: 0.15 },
          { name: 'headings', weight: 0.05 },
        ],
        threshold: 0.35,
        ignoreLocation: true,
        includeScore: true,
      }),
    [concepts]
  );

  const results = useMemo(
    () => (query.trim() ? fuse.search(query).slice(0, 8) : []),
    [fuse, query]
  );

  const goTo = (concept: Concept) => {
    setQuery('');
    setOpen(false);
    history.push(`/learn/${concept.topic}/${concept.id}`);
  };

  return (
    <div className="kb-search" ref={anchorRef}>
      <SearchIcon className="kb-search-icon" />
      <InputBase
        className="kb-search-input"
        placeholder="Search concepts…"
        value={query}
        inputProps={{ 'aria-label': 'search concepts' }}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && results.length > 0) goTo(results[0].item);
          if (e.key === 'Escape') setOpen(false);
        }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      <Popper
        open={open && results.length > 0}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        style={{ zIndex: 1400 }}
      >
        <Paper className="kb-search-results">
          <List dense>
            {results.map(({ item }) => (
              <ListItem
                button
                key={`${item.topic}/${item.id}`}
                onMouseDown={() => goTo(item)}
              >
                <ListItemText
                  primary={
                    <span className="kb-search-result-title">
                      {item.title} <Chip size="small" label={item.topic} />
                    </span>
                  }
                  secondary={item.description}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Popper>
    </div>
  );
};

export default SearchBar;
